// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext'; // ✅ AJOUTER

import { PERMISSIONS } from './utils/permissions';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Compteurs from './pages/Compteurs';
import Clients from './pages/Clients';
import Transactions from './pages/Transactions';
import Redevances from './pages/Redevances';
import Alertes from './pages/Alertes';
import Utilisateurs from './pages/Utilisateurs';
import Rapports from './pages/Rapports';
import AdvancedCenter from './pages/AdvancedCenter';
import MonitoringClients from './pages/MonitoringClients';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Comptabilite from './pages/Comptabilite';
// Components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ClientPortal from './pages/ClientPortal';
import RemoteControlPage from './pages/RemoteControlPage';
import PowerPlants from './pages/PowerPlants';
import Contrats from './pages/Contrats';
import GomelongRemoteControl from './pages/GomelongRemoteControl'; // ✅ AJOUT
// import WavePaymentClient from './pages/WavePaymentClient';

// Composant pour rediriger si déjà connecté
const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  
  if (user) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
     <ThemeProvider> {/* ✅ AJOUTER */}
 
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/client-portal" element={<ClientPortal />} /> {/* ✅ AJOUTER */} 
          {/* Route publique - Login */}
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } 
          />
          
          {/* Dashboard - Tous les utilisateurs connectés */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_DASHBOARD]}>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Profile - Accessible à tous les utilisateurs connectés */}
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Profile />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Settings - Accessible à tous les utilisateurs connectés */}
          <Route 
            path="/settings" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Compteurs - VIEW_METERS */}
          <Route 
            path="/compteurs" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_METERS]}>
                <Layout>
                  <Compteurs />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Clients - VIEW_CUSTOMERS */}
          <Route 
            path="/clients" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_CUSTOMERS]}>
                <Layout>
                  <Clients />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Transactions - VIEW_TRANSACTIONS */}
          <Route 
            path="/transactions" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_TRANSACTIONS]}>
                <Layout>
                  <Transactions />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Redevances - VIEW_FEES */}
          <Route 
            path="/redevances" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_FEES]}>
                <Layout>
                  <Redevances />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Alertes - VIEW_ALERTS */}
          <Route 
            path="/alertes" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_ALERTS]}>
                <Layout>
                  <Alertes />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Utilisateurs - VIEW_USERS (Admin seulement) */}
          <Route 
            path="/utilisateurs" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_USERS]}>
                <Layout>
                  <Utilisateurs />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Rapports - VIEW_REPORTS */}
          <Route 
            path="/rapports" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_REPORTS]}>
                <Layout>
                  <Rapports />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Centre Avancé - CONFIGURE_METER */}
          <Route 
            path="/centre_avance" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.CONFIGURE_METER]}>
                <Layout>
                  <AdvancedCenter />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* Surveillance Clients - VIEW_MONITORING */}
          <Route 
            path="/surveillance" 
            element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_MONITORING]}>
                <Layout>
                  <MonitoringClients />
                </Layout>
              </ProtectedRoute>
            } 
          />
              {/* Routes accessibles par tous les utilisateurs connectés */}
              <Route path="profile" element={<Profile />} />
              <Route path="settings" element={<Settings />} />
           
            <Route
              path="/comptabilite"
              element={
                <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_FEES]}>
                  <Layout>
                    <Comptabilite />
                  </Layout>
                </ProtectedRoute>
              }
            />
            {/* ✅ AJOUT : Contrôle à distance GOMELONG (eau + électricité) */}
            <Route path="/gomelong-remote" element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_REMOTE_CONTROL]}>
                <Layout>
                  <GomelongRemoteControl />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/remote-control" element={
              <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_REMOTE_CONTROL]}>
                <Layout>
                  <RemoteControlPage />
                </Layout>
              </ProtectedRoute>
            } />
            

              <Route
                path="/contrats"
                element={
                  <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_CONTRACTS]}>
                    <Layout>
                      <Contrats />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/centrales"
                element={
                  <ProtectedRoute requiredPermissions={[PERMISSIONS.VIEW_POWER_PLANTS]}>
                    <Layout>
                      <PowerPlants />
                    </Layout>
                  </ProtectedRoute>
                }
              />

          {/* <Route path="/wave-payment" element={<WavePaymentClient />} /> */}
          {/* Route 404 */}
          <Route 
            path="*" 
            element={
              <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
                <div className="text-center">
                  <h1 className="text-6xl font-bold text-gray-900 dark:text-white">404</h1>
                  <p className="text-xl text-gray-600 dark:text-gray-400 mt-4">Page non trouvée</p>
                  <button
                    onClick={() => window.location.href = '/'}
                    className="mt-6 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
                  >
                    Retour à l'accueil
                  </button>
                </div>
              </div>
            } 
          />
        </Routes>
      </Router>
    </AuthProvider>
    </ThemeProvider> 
  );
}

export default App;